import { useIntl } from 'react-intl';
import {
  TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_RISCO,
  TIPO_ITEM_FLUXO_APROVACAO,
} from 'src/utils/constants';

import LucideIcon from 'src/componentes/lucide-icon';
import Tooltip from 'src/componentes/tooltip';
import Input from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';
import InputNumber from 'src/componentes/input-number';
import ColaboradorEGrupoEResponsabilidadeLookup from 'src/lookups/ColaboradorEGrupoEResponsabilidadeLookup';
import GrauRiscoLookup from 'src/lookups/grau-risco';
import StatusItemLookup from 'src/lookups/status-item';

const Edit = ({
  model,
  index,
  etapa,
  provided,
  showTrashIcon,
  disabled,
  ehFluxoNegociacaoMetas,
  ehAvaliacaoRisco = false,
  ehGestaoDocumento = false,
  ehStageGate = false,
  ehGestaoMudancas = false,
  tipoItem = null,
  tipoSolicitacao = null,
}) => {
  const intl = useIntl();

  const handleChangeFields = (field, value) => {
    const newList = [...model.value];
    const item = newList[index];

    if (item) item[field] = value;

    model.requestChange(newList);
  };

  const handleChangePeopleAndGroupsAndResponsibilities = (list) => {
    const newApprovers =
      list?.filter((x) => x.identificadorLista === 'colaboradores') || [];
    const newGroups =
      list?.filter((x) => x.identificadorLista === 'grupos') || [];
    const newResponsibilities =
      list?.filter((x) => x.identificadorLista === 'responsabilidades') || [];

    handleChangeFields('aprovadores', newApprovers);
    handleChangeFields('gruposAprovadores', newGroups);
    handleChangeFields('responsabilidades', newResponsibilities);
  };

  const handleRemove = () => {
    const newList = [...model.value];
    newList.splice(index, 1);

    model.requestChange(newList);
  };

  const aprovadores = etapa.aprovadores || [];
  const gruposAprovadores = etapa.gruposAprovadores || [];
  const responsabilidades = etapa.responsabilidades || [];
  const grausRisco = etapa.grausRisco || [];
  const duracao = etapa.duracao || null;

  const exibirStatusRisco =
    tipoItem?.id === TIPO_ITEM_FLUXO_APROVACAO.RISCO &&
    tipoSolicitacao?.id ===
      TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_RISCO.ALTERACAO_STATUS_RISCO &&
    ehGestaoMudancas;

  const ehGestaoRisco = exibirStatusRisco;

  return (
    <tr
      ref={provided.innerRef}
      {...provided.draggableProps}
      style={{
        ...provided.draggableProps.style,
      }}
    >
      {!disabled && (
        <td
          style={{ width: '5%' }}
          className="text-center pt-1"
          {...provided.dragHandleProps}
        >
          <LucideIcon size={22} icon="drag" />
        </td>
      )}
      <td
        style={{
          width: '20%',
        }}
        className="pr-3 pt-1"
      >
        <Input
          autoFocus={false}
          formStyle={{ marginBottom: 0 }}
          disabled={disabled}
          model={{
            label: '',
            value: etapa.nome,
            requestChange: (v) => handleChangeFields('nome', v),
          }}
          required
        />
      </td>
      <td
        style={{ width: ehAvaliacaoRisco || exibirStatusRisco ? '45%' : '60%' }}
        className="pr-3 pt-1"
      >
        <ColaboradorEGrupoEResponsabilidadeLookup
          multi
          autoFocus={false}
          formGroupStyle={{ marginBottom: 0 }}
          disabled={disabled}
          ehFluxoNegociacaoMetas={ehFluxoNegociacaoMetas}
          ehAvaliacaoRisco={ehAvaliacaoRisco}
          ehGestaoDocumento={ehGestaoDocumento}
          ehStageGate={ehStageGate}
          ehGestaoRisco={ehGestaoRisco}
          model={{
            label: '',
            value: [...aprovadores, ...gruposAprovadores, ...responsabilidades],
            requestChange: handleChangePeopleAndGroupsAndResponsibilities,
          }}
          data={{ ehFluxoNegociacaoMetas: ehFluxoNegociacaoMetas }}
        />
      </td>
      {exibirStatusRisco && (
        <td style={{ width: '25%' }} className="pr-3 pt-1">
          <StatusItemLookup
            multi
            data-testid="risco-status-lookup"
            style={{ marginBottom: 0 }}
            controlStyle={{ minHeight: '40px' }}
            required
            model={{
              label: '',
              value: etapa.statusRisco,
              requestChange: (v) => handleChangeFields('statusRisco', v),
            }}
            data={{ idsSelecionados: [1, 2, 3, 4, 5] }}
          />
        </td>
      )}
      {ehAvaliacaoRisco && (
        <td style={{ width: '25%' }} className="pr-3 pt-1">
          <GrauRiscoLookup
            className="pt-3"
            multi
            model={{
              label: '',
              value: grausRisco,
              requestChange: (v) => handleChangeFields('grausRisco', v),
            }}
          />
        </td>
      )}
      {ehGestaoDocumento && (
        <td style={{ width: '10%' }} className="pr-3 pt-1">
          <InputNumber
            formStyle={{ marginBottom: 0 }}
            model={{
              label: '',
              value: duracao,
              requestChange: (v) => handleChangeFields('duracao', v),
            }}
          />
        </td>
      )}
      <td style={{ width: '15%' }} className="pr-3 pt-1">
        <div className="d-flex align-items-center font-weight-bold">
          <Checkbox
            autoFocus={false}
            disabled={disabled}
            model={{
              label: intl.formatMessage({ id: 'aprovacaoUnica' }),
              value: etapa.aprovacaoUnica,
              requestChange: (v) => handleChangeFields('aprovacaoUnica', v),
            }}
          />
          <Tooltip
            text={intl.formatMessage({ id: 'aprovacaoUnicaExplicacao' })}
            maxWidth={300}
          >
            <LucideIcon
              size={14}
              className="ml-2 text-muted"
              icon="information-outline"
            />
          </Tooltip>
        </div>
      </td>
      {showTrashIcon && !disabled && (
        <td style={{ width: '5%' }} className="text-center text-primary pt-1">
          <LucideIcon
            size={20}
            onClick={handleRemove}
            className="cursor-pointer"
            icon="delete"
          />
        </td>
      )}
    </tr>
  );
};

export default Edit;
